import modulesMap from 'core/modulesMap';
import MainPage from './MainPage';
export default class InternalPage extends MainPage {
    constructor(el, options) {
        super(el, options);
        el.classList.add('internal-page');
    }
    getModulesMap() {
        return Object.assign({}, modulesMap);
    }
    /* SHOW */
    askPreload(previousPage) {
        if (previousPage)
            this.el.style.opacity = '0';
        return super.askPreload(...arguments);
    }
    preload(previousPage) {
        if (previousPage)
            return super.preload(...arguments);
        else
            return Promise.resolve();
    }
    getChildrenShowDelay() {
        const { previousMainPage, previousPage } = this.options;
        return super.getChildrenShowDelay() + ((!previousPage && !previousMainPage) ? 800 : 0);
    }
    show(previousPage) {
        if (!previousPage) {
            this.el.style.opacity = '1';
            this.showChildren();
            return Promise.resolve();
        }
        else {
            return super.show(previousPage);
        }
    }
}
